import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  Timestamp,
  doc,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../../config';
import {
  CreateResultHistoryRequest,
  ResultHistory,
  ResultHistoryActionType,
} from '../../../../types/resultHistory';

/**
 * 履歴レコードを作成
 */
export const createResultHistory = async (request: CreateResultHistoryRequest): Promise<void> => {
  try {
    const historyRef = collection(db, 'results', request.result_id, 'result_history');

    const historyData = {
      action_type: request.action_type,
      changed_fields: request.changed_fields || null,
      previous_values: request.previous_values || null,
      user_id: request.user_id,
      user_name: request.user_name,
      created_at: Timestamp.now(),
    };

    const docRef = await addDoc(historyRef, historyData);

    // history_idを更新
    await updateDoc(doc(db, 'results', request.result_id, 'result_history', docRef.id), {
      history_id: docRef.id,
    });
  } catch (error) {
    throw new Error('履歴の記録に失敗しました');
  }
};

/**
 * 初回OCR結果（CREATE履歴）を取得する
 */
export const getCreateHistory = async (resultId: string): Promise<ResultHistory | null> => {
  const historyRef = collection(db, 'results', resultId, 'result_history');
  const q = query(historyRef, where('action_type', '==', ResultHistoryActionType.CREATE));
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  return snapshot.docs[0].data() as ResultHistory;
};

/**
 * EDIT履歴が1件以上存在するか確認する
 */
export const hasAnyEditHistory = async (resultId: string): Promise<boolean> => {
  const historyRef = collection(db, 'results', resultId, 'result_history');
  const q = query(historyRef, where('action_type', '==', ResultHistoryActionType.EDIT));
  const snapshot = await getDocs(q);
  return !snapshot.empty;
};
